import { useState, useEffect } from "react";

const isMobileDevice = (): boolean => {
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;
  const isMobileByUserAgent =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );

  const hasTouchScreen =
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    (navigator as any).msMaxTouchPoints > 0;

  if (isMobileByUserAgent) {
    return true;
  }

  if (hasTouchScreen) {
    return true;
  }

  return false;
};

export const useDeviceType = (): "mobile" | "desktop" => {
  const [device, setDevice] = useState<"mobile" | "desktop">(() =>
    isMobileDevice() ? "mobile" : "desktop"
  );

  useEffect(() => {
    const onResize = () => {
      setDevice(isMobileDevice() ? "mobile" : "desktop");
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return device;
};
